import { Component } from "../../view/index";
import { Template, LazyTemplate } from "../../template/index";
import ListViewItem, { ListViewItemData, ListViewItemConstructor } from "./item/index";

export default class ListView extends Component
{
    public template = Template.lazy('/core/component/listView/index.html');
    public data: ListViewData;
    public items: ListViewItem[];
    public itemType: ListViewItemConstructor;
    private container: HTMLElement;

    public static readonly EVENTS = {
        ITEM_CLICKED: 'itemClicked'
    };

    private itemId = 0;
    public get nextItemId() { return this.itemId++; }

    constructor(data: ListViewData, itemType: ListViewItemConstructor = ListViewItem)
    {
        super(data);
        this.itemType = itemType;
    }

    public beforeRender()
    {
        return super.beforeRender().then(() =>
        {
            this.items = [];

            this.items = this.data.initialItems.map(o => new this.itemType(this, o));
            return Promise.all(this.items.map(o => this.app.renderPartialView(o)));
        }).then(() =>
        {

        });
    }

    public afterRender()
    {
        return super.afterRender().then(() =>
        {
            for(let item of this.items)
            {
                this.container.appendChild(item.element);
            }
        });
    }

    public addItem(itemOrData: ListViewItem | ListViewItemData)
    {
        if (!(itemOrData instanceof ListViewItem))
        {
            itemOrData = new this.itemType(this, itemOrData);
        }

        let item = itemOrData as ListViewItem;
        this.items.push(item);
        return this.app.renderPartialView(item).then(() =>
        {
            this.container.appendChild(item.element);
        });
    }

    public removeItem(item: ListViewItem)
    {
        this.items.splice(this.items.indexOf(item), 1);
        this.container.removeChild(item.element);
    }

    public refresh()
    {
        return this.app.renderPartialView(this, this.element.parentElement, true);
    }
}

export interface ListViewData
{
    initialItems?: ListViewItemData[];
}

